<coa-list-no-data
  [title]="'No data for foot traffic' | translate">
</coa-list-no-data>
